import type { TileArgs } from 'react-calendar';

/**
 * Disable tiles with a minimum date (minDate) condition.
 */
export const disableTile = (minDate: Date | null, { date, view }: TileArgs) => {
  if (minDate === null) {
    return false;
  }

  minDate.setHours(0, 0, 0, 0);
  date.setHours(0, 0, 0, 0);

  if (view === 'year') {
    const currentMonth = new Date(minDate.getFullYear(), minDate.getMonth(), 1);

    return currentMonth > date;
  }

  if (view === 'decade') {
    const currentYear = new Date(minDate.getFullYear(), 0, 1);

    return currentYear > date;
  }

  if (view === 'century') {
    const currentCentury = new Date(minDate.getFullYear(), 0, 1);

    date.setFullYear(date.getFullYear() + 10);
    date.setDate(date.getDate() - 1);

    const endOfCentury = new Date(date);

    return currentCentury > endOfCentury;
  }

  return minDate > date;
};
